import { createContext, use } from "react";
import { FuseRoutesType } from "@fuse/utils/FuseUtils";

/**
 * Tipo do valor do AppContext.
 */
export type AppContextType = {
	/**
	 * Rotas a serem usadas no app.
	 */
	routes: FuseRoutesType;
	showSensitiveValues: boolean;
	setShowSensitiveValues: (value: boolean) => void;
	toggleSensitiveValues: () => void;
};

/**
 * Objeto AppContext.
 */
const AppContext = createContext<AppContextType | undefined>(undefined);

export function useAppContext() {
	const context = use(AppContext);
	if (context === undefined) throw new Error("useAppContext deve ser usado dentro de um AppContextProvider");

	return context;
}

export default AppContext;
